import { AntenApps, PageContent } from "src/models";

export type Pages = {
    aboutUs: PageContent;
    packageGuide: PageContent;
    apps: {
        data: AntenApps;
        loaded: boolean;
    }
};

export const PagesInitialState: Pages = {
    aboutUs: {
        uniqueKey: "about_us",
        htmlBody: "",
        title: "",
        loaded: false
    },
    packageGuide: {
        uniqueKey: "package_guide",
        htmlBody: "",
        title: "",
        loaded: false
    },
    apps: {
        data: {
            android: [],
            tv: [],
            ios: []
        },
        loaded: false
    }
};